import { UPDATETOPICCLASS } from '../type';
import fatch from '@utils/fatch.js';
export default {
  namespaced: true,
  state: {
    // 默认取sesstionstorage中的用户信息, 如果没有数据则为 ''
    list: [],
    total: 0
  },
  mutations: {
    [UPDATETOPICCLASS] (state, list, total) {
      // 合并用户信息
      state.list = list;
      state.total = total;
    }
  },
  actions: {
    async updateTopicClass ({ commit }) {
      try {
        let res = await fatch.releaseCategoryList({
          pageSize: 1e5,
          pageNow: 1
        });
        commit(UPDATETOPICCLASS, res.list, res.total);
      } catch (err) {
        console.log(err.msg || '获取分类错误~');
      }
    },
    async getList ({ state, dispatch }) {
      if (state.list && state.list.length === 0) {
        await dispatch('updateTopicClass');
      }
      return {
        list: state.list,
        total: state.total
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/vuex/modules/topic-class.js